import { i18n } from 'src/i18n';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';

export default [
  {
    name: 'name',
    label: 'name',
    schema: schemas.string(
      i18n('entities.asset.fields.name'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'classification',
    label: 'classification',
    schema: schemas.string(
      i18n('entities.asset.fields.classification'),
      {
        required: true,
      },
    ),
  },
];
